<template>
  <div class="powered">
    <div v-if="visible" class="content">
      <p
          v-text="title"
          class="title"/>

      <div class="powered__wrapper">
        <div
            v-for="(item, index) in list"
            :key="index"
            class="powered__item">
          <img
              :alt="item.alt"
              :src="require(`@/assets/img/${item.logo}`)"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Powered',
  props: {
    visible: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    list: [
      {
        alt: 'unreal engine',
        logo: 'powered/ue.svg',
      },
      {
        alt: 'paypro',
        logo: 'powered/paypro.svg',
      },
      {
        alt: 'aws',
        logo: 'powered/aws.svg',
      },
      {
        alt: 'nvidia',
        logo: 'powered/nvidia.svg',
      },
    ],
    title: 'Powered by',
  }),
};
</script>
